/** Remaining orders in the strategy pile (matches BattleUI S: counter). */
export function getStrategyHudTotal(playerState) {
  if (!playerState) return 0;

  // Primary: physical cards still in the strategy pile (countdown on draw, includes dynamic adds).
  // mulliganedOrders are temporarily out of deck until the next shuffle — still part of the pile.
  if (Array.isArray(playerState.deck)) {
    return playerState.deck.length
      + (playerState.mulliganedOrders?.length ?? 0)
      + (playerState.drawPile?.length ?? 0)
      + (playerState.draw_pile?.length ?? 0);
  }

  // Fallback when deck is not on state yet (loading / pre-battle).
  const baseOrders = Array.isArray(playerState.strategy?.orders) ? playerState.strategy.orders : [];
  const baseTotal = baseOrders.reduce((sum, order) => sum + (Number(order?.count) || 1), 0);
  const baseStrategyOrderIds = new Set(baseOrders.map((order) => Number(order?.id)).filter(Number.isFinite));
  const deckLikeOrders = [
    ...(playerState.drawPile || []),
    ...(playerState.draw_pile || []),
  ];
  const dynamicAddedTotal = deckLikeOrders.reduce((sum, order) => {
    const idNum = Number(order?.id);
    if (!Number.isFinite(idNum) || baseStrategyOrderIds.has(idNum)) return sum;
    return sum + 1;
  }, 0);

  return baseTotal + dynamicAddedTotal;
}
